import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

interface LogsFilteredEmptyStateProps {
  onClearFilters: () => void;
}

/**
 * Zero-events state for the Logs page (sc-44238 State 3), in the Design
 * System's empty-state pattern (sc-46029 AC4) — the same status block the
 * API Keys page uses (`.api-keys-status-*` in pages/api_keys.css): accent
 * icon circle, title, description and a pill CTA.
 */
const LogsFilteredEmptyState: React.FC<LogsFilteredEmptyStateProps> = ({ onClearFilters }) => (
  <div className="api-keys-status-block">
    <div className="api-keys-status-icon api-keys-status-icon--accent">
      <FontAwesomeIcon icon={faMagnifyingGlass} />
    </div>
    <h2 className="api-keys-status-title">No events found</h2>
    <p className="api-keys-status-description">
      Try adjusting your search or clearing the filters.
    </p>
    <button type="button" onClick={onClearFilters} className="api-keys-retry-btn">
      Clear filters
    </button>
  </div>
);

export default LogsFilteredEmptyState;
